export default __webpack_public_path__ + "static/logo-arnia-2752bbe1646377b27dd9c218c622424a.jpg";